import React from "react";

import { formatDate } from "../../../../../../utils/DateHelpers";
import NewDatePicker from "../../../../../shared/forms/DatePicker";

const DatePicker = ({
    value,
    onChange,
    minDate,
    maxDate,
    isAvailable,
    label,
}) => {
    const onDateChanged = (date) => {
        onChange(formatDate(date));
    };

    /**
     * Checks if the given date is a weekday and also 2 Days after today.
     * @param {*} date
     */
    // const isAvailable = date => {
    //     const validFrom = new Date();
    //     const day = date.getDay();
    //
    //     validFrom.setDate(validFrom.getDate() + 1);
    //
    //     return validFrom.getTime() < date.getTime();
    // };

    return (
        <NewDatePicker
            value={value !== "" ? new Date(value) : value}
            onChange={onDateChanged}
            filterDate={isAvailable}
            className="input is-full-width"
            maxDate={maxDate}
            minDate={minDate}
            label={label}
        />
    );
};

export default DatePicker;
